import { useTranslation } from "react-i18next";

import ContactForm from "Features/ContactForm/ContactForm";

// Styles
import "./Contact.scss";
import useIsMobile from "Hooks/useIsMobile";

const Contact = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <section id="contact" className="contact">
      <div className="contact_form">
        <div className="contact_form-text">
          <h2>{t("contact.title")}</h2>
          <p>{t("contact.title2")} </p>
        </div>
        <ContactForm />
      </div>
      <div className="contact_info">
        <div className="contact_info-title">
          <h2>{t("contact.info.title")}</h2>
        </div>
        <div className="contact_info-description">
          <span className="mobile-contact">
            <h3 className="subtitle">{t("contact.info.address")}</h3>
            {isMobile ? (
              <p>
                {t("contact.info.addressInfo")} -{" "}
                {t("contact.info.addressInfo2")}
                <br />
              </p>
            ) : (
              <span>
                {t("contact.info.addressInfo")}
                <br />
                <p>{t("contact.info.addressInfo2")}</p>
              </span>
            )}
          </span>

          <span className="mobile-contact">
            <h3 className="subtitle">{t("contact.info.subtitle")}</h3>
            <span>
              {t("contact.info.mark")}
              <br />
              {t("contact.info.mark2")}
            </span>
            <span>
              {t("contact.info.tel")}
              <br />
              {t("contact.info.mail")}
            </span>
          </span>
        </div>
      </div>
    </section>
  );
};

export default Contact;
